<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper blank-page">
    <!-- Header -->
    <layout-header />
    <!-- /Header -->

    <!-- Breadcrumb -->
    <div class="breadcrumb-bar">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12 col-12">
            <h2 class="breadcrumb-title">Politique d'Annulation</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- /Breadcrumb -->

    <!-- Page Content -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-12 pb-4">
            <h4>1. Introduction</h4>
            <p>La présente Politique d'Annulation définit les conditions selon lesquelles les utilisateurs peuvent annuler une réservation effectuée sur la plateforme **6v6**.</p>
            <h4>2. Conditions d'Annulation</h4>
            <p>Les conditions d'annulation varient en fonction des partenaires propriétaires des terrains. Chaque partenaire définit un délai spécifique avant la réservation pendant le</p>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- Footer -->
    <layout-footer />
    <!-- /Footer -->
  </div>
</template>
<script>
export default {
  mounted() {
    // Content div min height set

    function resizeInnerDiv() {
      var height = $(window).height();
      var header_height = $(".header").height();
      var footer_height = $(".footer").height();
      var breadcrumb_height = $(".breadcrumb-bar").height();
      var setheight = height - breadcrumb_height - header_height;
      var trueheight = setheight - footer_height;
      $(".content").css("min-height", trueheight - 30);
    }

    if ($(".content").length > 0) {
      resizeInnerDiv();
    }

    $(window).resize(function () {
      if ($(".content").length > 0) {
        resizeInnerDiv();
      }
    });
  },
};
</script>
